import { c as _c } from "react/compiler-runtime";
import DropPfp from "@/components/drops/create/utils/DropPfp";
import { useIdentity } from "@/hooks/useIdentity";
import UserFollowBtn, { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import UserCICAndLevel, { UserCICAndLevelSize } from "../UserCICAndLevel";
import UserProfileTooltipTopRep from "./UserProfileTooltipTopRep";
import { ApiProfileRepRatesState, CLASSIFICATIONS, CicStatement } from "@/entities/IProfile";
import { useQuery } from "@tanstack/react-query";
import { commonApiFetch } from "@/services/api/common-api";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { STATEMENT_GROUP, STATEMENT_TYPE } from "@/helpers/Types";
import { useContext, useEffect, useMemo, useState } from "react";
import { AuthContext } from "@/components/auth/Auth";
import UserStatsRow, { UserStatsRowSize } from "../stats/UserStatsRow";
import { ApiIncomingIdentitySubscriptionsPage } from "@/generated/models/ApiIncomingIdentitySubscriptionsPage";
export default function UserProfileTooltip(t0) {
  const $ = _c(80);
  const {
    user
  } = t0;
  let t1;
  if ($[0] !== user) {
    t1 = {
      handleOrWallet: user,
      initialProfile: null
    };
    $[0] = user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    profile
  } = useIdentity(t1);
  let t2;
  if ($[2] !== user) {
    t2 = user.toLowerCase();
    $[2] = user;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = [QueryKey.PROFILE_REP_RATINGS, {
      handleOrWallet: t2
    }];
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== user) {
    t4 = async () => await commonApiFetch({
      endpoint: `profiles/${user}/rep/ratings/received`
    });
    $[6] = user;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = !!user && !!profile?.handle;
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const {
    data: repRates
  } = useQuery(t6);
  let t7;
  if ($[12] !== user) {
    t7 = user.toLowerCase();
    $[12] = user;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = [QueryKey.PROFILE_CIC_STATEMENTS, t7];
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== user) {
    t9 = async () => await commonApiFetch({
      endpoint: `profiles/${user}/cic/statements`
    });
    $[16] = user;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = !!user && !!profile?.handle;
  let t11;
  if ($[18] !== t10 || $[19] !== t8 || $[20] !== t9) {
    t11 = {
      queryKey: t8,
      queryFn: t9,
      enabled: t10
    };
    $[18] = t10;
    $[19] = t8;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const {
    data: statements
  } = useQuery(t11);
  const t12 = profile?.id;
  let t13;
  if ($[22] !== t12) {
    t13 = [QueryKey.IDENTITY_FOLLOWERS, {
      profile_id: t12,
      page_size: 1
    }];
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== profile?.id) {
    t14 = async () => await commonApiFetch({
      endpoint: `identity-subscriptions/incoming/IDENTITY/${profile?.id}`,
      params: {
        page_size: "1"
      }
    });
    $[24] = profile?.id;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  const t15 = !!profile?.id;
  let t16;
  if ($[26] !== t13 || $[27] !== t14 || $[28] !== t15) {
    t16 = {
      queryKey: t13,
      queryFn: t14,
      enabled: t15
    };
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  const {
    data: followersData
  } = useQuery(t16);
  const followersCount = followersData?.count ?? 0;
  const [aboutStatement, setAboutStatement] = useState(null);
  let t17;
  let t18;
  if ($[30] !== statements) {
    t17 = () => {
      const about = statements?.find(_temp);
      setAboutStatement(about ?? null);
    };
    t18 = [statements];
    $[30] = statements;
    $[31] = t17;
    $[32] = t18;
  } else {
    t17 = $[31];
    t18 = $[32];
  }
  useEffect(t17, t18);
  const description = profile?.classification ? CLASSIFICATIONS[profile.classification]?.title : null;
  const {
    connectedProfile
  } = useContext(AuthContext);
  const profileHandle = profile?.handle ?? null;
  let t19;
  if ($[33] !== profileHandle) {
    t19 = profileHandle?.toLowerCase() ?? null;
    $[33] = profileHandle;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  const normalizedProfileHandle = t19;
  let t20;
  if ($[35] !== connectedProfile?.handle) {
    t20 = () => connectedProfile?.handle?.toLowerCase() ?? null;
    $[35] = connectedProfile?.handle;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  connectedProfile?.handle;
  let t21;
  if ($[37] !== t20) {
    t21 = t20();
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  const normalizedConnectedHandle = t21;
  const showFollowButton = Boolean(normalizedProfileHandle && normalizedProfileHandle !== normalizedConnectedHandle);
  const t22 = profile?.pfp;
  let t23;
  if ($[39] !== t22) {
    t23 = <div className="tw-flex-shrink-0"><DropPfp pfpUrl={t22} /></div>;
    $[39] = t22;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  const t24 = profile?.handle ?? profile?.display;
  let t25;
  if ($[41] !== t24) {
    t25 = <span className="tw-text-base tw-font-bold tw-text-iron-50 tw-truncate tw-max-w-[180px]">{t24}</span>;
    $[41] = t24;
    $[42] = t25;
  } else {
    t25 = $[42];
  }
  let t26;
  if ($[43] !== profile) {
    t26 = profile && <UserCICAndLevel level={profile.level} size={UserCICAndLevelSize.SMALL} />;
    $[43] = profile;
    $[44] = t26;
  } else {
    t26 = $[44];
  }
  let t27;
  if ($[45] !== t25 || $[46] !== t26) {
    t27 = <div className="tw-flex tw-items-center tw-gap-x-2">{t25}{t26}</div>;
    $[45] = t25;
    $[46] = t26;
    $[47] = t27;
  } else {
    t27 = $[47];
  }
  let t28;
  if ($[48] !== description) {
    t28 = description && <p className="tw-text-xs tw-text-iron-400 tw-mb-0">{description}</p>;
    $[48] = description;
    $[49] = t28;
  } else {
    t28 = $[49];
  }
  let t29;
  if ($[50] !== t27 || $[51] !== t28) {
    t29 = <div className="tw-flex tw-flex-col tw-min-w-0">{t27}{t28}</div>;
    $[50] = t27;
    $[51] = t28;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  if ($[53] !== t23 || $[54] !== t29) {
    t30 = <div className="tw-flex tw-flex-col tw-gap-2 tw-flex-1 tw-min-w-0">{t23}{t29}</div>;
    $[53] = t23;
    $[54] = t29;
    $[55] = t30;
  } else {
    t30 = $[55];
  }
  let t31;
  if ($[56] !== profileHandle || $[57] !== showFollowButton) {
    t31 = showFollowButton && profileHandle && <div className="tw-flex-shrink-0"><UserFollowBtn handle={profileHandle} size={UserFollowBtnSize.SMALL} /></div>;
    $[56] = profileHandle;
    $[57] = showFollowButton;
    $[58] = t31;
  } else {
    t31 = $[58];
  }
  let t32;
  if ($[59] !== t30 || $[60] !== t31) {
    t32 = <div className="tw-flex tw-items-start tw-justify-between tw-gap-x-3">{t30}{t31}</div>;
    $[59] = t30;
    $[60] = t31;
    $[61] = t32;
  } else {
    t32 = $[61];
  }
  let t33;
  if ($[62] !== aboutStatement) {
    t33 = aboutStatement && <p className="tw-text-sm tw-text-iron-200 tw-line-clamp-2 tw-mb-0 tw-mt-4">{aboutStatement.statement_value}</p>;
    $[62] = aboutStatement;
    $[63] = t33;
  } else {
    t33 = $[63];
  }
  const t34 = profile?.handle ?? user;
  const t35 = profile?.tdh ?? 0;
  const t36 = profile?.tdh_rate ?? 0;
  const t37 = profile?.xtdh ?? 0;
  const t38 = profile?.xtdh_rate ?? 0;
  const t39 = profile?.rep ?? 0;
  const t40 = profile?.cic ?? 0;
  let t41;
  if ($[64] !== followersCount || $[65] !== t34 || $[66] !== t35 || $[67] !== t36 || $[68] !== t37 || $[69] !== t38 || $[70] !== t39 || $[71] !== t40) {
    t41 = <div className="tw-mt-4"><UserStatsRow handle={t34} tdh={t35} tdh_rate={t36} xtdh={t37} xtdh_rate={t38} rep={t39} cic={t40} followersCount={followersCount} size={UserStatsRowSize.SMALL} /></div>;
    $[64] = followersCount;
    $[65] = t34;
    $[66] = t35;
    $[67] = t36;
    $[68] = t37;
    $[69] = t38;
    $[70] = t39;
    $[71] = t40;
    $[72] = t41;
  } else {
    t41 = $[72];
  }
  let t42;
  if ($[73] !== repRates) {
    t42 = <UserProfileTooltipTopRep repRates={repRates} />;
    $[73] = repRates;
    $[74] = t42;
  } else {
    t42 = $[74];
  }
  let t43;
  if ($[75] !== t32 || $[76] !== t33 || $[77] !== t41 || $[78] !== t42) {
    t43 = <div className="tailwind-scope tw-bg-iron-950 tw-min-w-[280px] tw-max-w-[320px]">{t32}{t33}{t41}{t42}</div>;
    $[75] = t32;
    $[76] = t33;
    $[77] = t41;
    $[78] = t42;
    $[79] = t43;
  } else {
    t43 = $[79];
  }
  return t43;
}
function _temp(statement) {
  return statement.statement_type === STATEMENT_TYPE.BIO && statement.statement_group === STATEMENT_GROUP.GENERAL;
}